import React from 'react';
import DashboardHeader from '@/components/dashboard/DashboardHeader';
import DashboardContent from '@/components/dashboard/DashboardContent';
import DashboardLoadingState from '@/components/dashboard/DashboardLoadingState';
import ProfileModal from '@/components/ProfileModal';

interface DesktopUserDashboardProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  filtersExpanded: boolean;
  tableExpanded: boolean;
  selectedIdealProfile: any;
  setSelectedIdealProfile: (profile: any) => void;
  handleToggleTable: () => void;
  handleToggleFilters: () => void;
  loading: boolean;
  dataLoadError: string | null;
  totalCounts: { behavioral: number; idealProfiles: number };
  behavioralSubmissions: any[];
  workBehaviorSubmissions: any[];
  idealProfiles: any[];
  filteredBehavioralCount: number;
  filteredWorkBehaviorCount: number;
  deletingProfileIds: Set<string>;
  searchTerm: string;
  isSearching: boolean;
  currentFilters: any;
  behavioralPagination: any;
  workBehaviorPagination: any;
  profilesPagination: any;
  handleViewDetails: (submission: any) => void;
  handleSubmissionDeleted: (id: string) => void;
  handleDeleteProfile: (profile: any) => void;
  handleFiltersChange: (filters: any) => void;
  handleSearchChange: (term: string) => void;
  handleSignOut: () => void;
  selectedSubmission: any;
  isModalOpen: boolean;
  handleCloseModal: () => void;
  getPageTitle: () => string;
  subscribed: boolean;
  onManageSubscription: () => void;
  updateSubmissionStatus: (submissionId: string, newStatus: string) => Promise<void>;
  profileFilter: string;
  handleProfileFilterChange: (value: string) => void;
}

const DesktopUserDashboard: React.FC<DesktopUserDashboardProps> = ({
  activeTab,
  setActiveTab,
  filtersExpanded,
  tableExpanded,
  selectedIdealProfile,
  setSelectedIdealProfile,
  handleToggleTable,
  handleToggleFilters,
  loading,
  dataLoadError,
  totalCounts,
  behavioralSubmissions,
  workBehaviorSubmissions,
  idealProfiles,
  filteredBehavioralCount,
  filteredWorkBehaviorCount,
  deletingProfileIds,
  searchTerm,
  isSearching,
  currentFilters,
  behavioralPagination,
  workBehaviorPagination,
  profilesPagination,
  handleViewDetails,
  handleSubmissionDeleted,
  handleDeleteProfile,
  handleFiltersChange,
  handleSearchChange,
  handleSignOut,
  selectedSubmission,
  isModalOpen,
  handleCloseModal,
  getPageTitle,
  subscribed,
  onManageSubscription,
  updateSubmissionStatus,
  profileFilter,
  handleProfileFilterChange
}) => {
  return (
    <>
      <DashboardHeader
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        getPageTitle={getPageTitle}
        subscribed={subscribed}
        handleManageSubscription={onManageSubscription}
        handleSignOut={handleSignOut}
        totalCounts={{
          behavioralSubmissions: totalCounts.behavioral,
          cognitiveSubmissions: 0,
          idealProfiles: totalCounts.idealProfiles
        }}
      />
      
      <DashboardLoadingState
        loading={loading}
        dataLoadError={dataLoadError}
      >
        <DashboardContent
          activeTab={activeTab}
          totalCounts={totalCounts}
          behavioralSubmissions={behavioralSubmissions}
          workBehaviorSubmissions={workBehaviorSubmissions}
          currentFilters={currentFilters}
          onFiltersChange={handleFiltersChange}
          filtersExpanded={filtersExpanded}
          onToggleFilters={handleToggleFilters}
          onViewDetails={handleViewDetails}
          onSubmissionDeleted={handleSubmissionDeleted}
          onStatusUpdate={updateSubmissionStatus}
          behavioralPagination={behavioralPagination}
          workBehaviorPagination={workBehaviorPagination}
          filteredBehavioralCount={filteredBehavioralCount}
          filteredWorkBehaviorCount={filteredWorkBehaviorCount}
          searchTerm={searchTerm}
          isSearching={isSearching}
          onSearchChange={handleSearchChange}
          tableExpanded={tableExpanded}
          onToggleTable={handleToggleTable}
          selectedIdealProfile={selectedIdealProfile}
          setSelectedIdealProfile={setSelectedIdealProfile}
          idealProfiles={idealProfiles}
          onDeleteProfile={handleDeleteProfile}
          deletingProfileIds={deletingProfileIds}
          profilesPagination={profilesPagination}
          profileFilter={profileFilter}
          onProfileFilterChange={handleProfileFilterChange}
        />
      </DashboardLoadingState>

      {/* Profile Modal */}
      <ProfileModal
        submission={selectedSubmission}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />
    </>
  );
};

export default DesktopUserDashboard;
